import {
    GET_TECH_STATUS_STARTED,
    GET_TECH_STATUS_FINISHED,
    GET_TECH_STATUS_FAILED,
    SET_TECH_STATUS_READY,
    SET_TECH_STATUS_IN_ROUTE,
    SET_TECH_STATUS_ON_JOB,
    SET_TECH_STATUS_UNDO_IN_ROUTE,
    SET_TECH_STATUS_UNDO_ON_JOB,
    SET_TECH_STATUS_NOT_READY,
    SET_TECH_STATUS_ON_BREAK,
    SET_TECH_STATUS_OFF_BREAK,
    SET_TECH_STATUS_FINISHED,
    SET_TECH_STATUS_FAILED,
    SET_TECH_STATUS_WAITING,
    SHOW_ARRIVAL_TIME_DIALOG,
    SET_ARRIVAL_TIME,
    SET_PUBNUB_TOKEN
} from 'constants/actionTypes';

export const setTechStatusWaiting = (payload, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_WAITING, payload, userId, timestamp });

export const getTechStatusStarted = (request, userId, timestamp = new Date()) => ({ type: GET_TECH_STATUS_STARTED, request, userId, timestamp });
export const getTechStatusFinished = (payload, userId, timestamp = new Date()) => ({ type: GET_TECH_STATUS_FINISHED, payload, userId, timestamp });
export const getTechStatusFailed = (payload, userId, timestamp = new Date()) => ({ type: GET_TECH_STATUS_FAILED, payload, userId, timestamp });

export const setTechStatusReady = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_READY, request, userId, timestamp });
export const setTechStatusInRoute = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_IN_ROUTE, request, userId, timestamp });
export const setTechStatusOnJob = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_ON_JOB, request, userId, timestamp });
export const setTechStatusUndoInRoute = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_UNDO_IN_ROUTE, request, userId, timestamp });
export const setTechStatusUndoOnJob = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_UNDO_ON_JOB, request, userId, timestamp });
export const setTechStatusNotReady = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_NOT_READY, request, userId, timestamp });
export const setTechStatusOnBreak = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_ON_BREAK, request, userId, timestamp });
export const setTechStatusOffBreak = (request, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_OFF_BREAK, request, userId, timestamp });

export const setTechStatusFinished = (payload, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_FINISHED, payload, userId, timestamp });
export const setTechStatusFailed = (payload, userId, timestamp = new Date()) => ({ type: SET_TECH_STATUS_FAILED, payload, userId, timestamp });
export const showArrivalTimeDialog = (userId, firstWorkOrderNumber) => ({ type: SHOW_ARRIVAL_TIME_DIALOG, userId, firstWorkOrderNumber });
export const setNextArrivalTime = (arrivalTime, userId) => ({ type: SET_ARRIVAL_TIME, arrivalTime, userId });

export const setPubNubToken = (token) => ({ type: SET_PUBNUB_TOKEN, token });





// WEBPACK FOOTER //
// ./src/actions/statusActions.js